import { render, staticRenderFns } from "./CardSectionComments.vue?vue&type=template&id=31aa4da7&"
import script from "./CardSectionComments.vue?vue&type=script&lang=js&"
export * from "./CardSectionComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports